export default __webpack_public_path__ + "static/media/r6x-logo-tch.8f8cef82.png";